/* JSON Web Tokens that are used as authentication header. */

export function authHeader() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.data && user.data.accessToken) {
        return { 'Authorization': 'Bearer ' + user.data.accessToken };
    } else {
        return {};
    }
}

/**
 * Decode JWT token and extract roles
 * @param {string} token - JWT token
 * @returns {string[]} Array of roles
 */
export function decodeJWT(token) {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        const decoded = JSON.parse(jsonPayload);
        
        // Extract roles from the token
        // The roles are typically in 'role' claim or 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'
        const roles = decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || 
                     decoded.role || 
                     (Array.isArray(decoded.roles) ? decoded.roles : [decoded.roles]).filter(Boolean);
        
        return Array.isArray(roles) ? roles : [roles];
    } catch (e) {
        console.error('Error decoding JWT:', e);
        return [];
    }
}

/**
 * Get user roles from stored token
 * @returns {string[]} Array of roles
 */
export function getUserRoles() {
    try {
        const user = JSON.parse(localStorage.getItem('user'));
        if (user && user.data && user.data.accessToken) {
            return decodeJWT(user.data.accessToken);
        }
    } catch (e) {
        console.error('Error getting user roles:', e);
    }
    return [];
}

/**
 * Check if user has Admin role
 * @returns {boolean}
 */
export function isAdmin() {
    const roles = getUserRoles();
    return roles.includes('Admin') || roles.includes('1');
}

/**
 * Check if user has User role (EcommerceManager)
 * @returns {boolean}
 */
export function isUser() {
    const roles = getUserRoles();
    return roles.includes('User') || roles.includes('2');
}